import { useState } from "react";
import { X } from "react-feather";
import { Spinner } from "@/components/ui/spinner";

interface BrandPreviewProps {
  /** The brand's username: the join page is addressed by it. */
  username: string;
  onClose?: () => void;
}

/**
 * Full-page preview of the brand's join page, as an affiliate meets it.
 *
 * This used to be a hand-drawn copy of the join page, which drifted: it knew
 * nothing about appearance themes and showed the standard layout to brands
 * whose custom page is live. Embedding the real `/store/:username/join` route
 * means whatever the visitor would see — templated or custom — is what the
 * brand sees here, with nothing to keep in sync.
 */
export function BrandPreview({ username, onClose = () => {} }: BrandPreviewProps) {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className="fixed inset-0 z-50 bg-background">
      <div className="absolute right-4 top-4 z-10">
        <button
          type="button"
          onClick={onClose}
          className="inline-flex items-center rounded-lg bg-brand-600 px-3 py-2 text-white shadow-sm hover:bg-brand-700"
        >
          <X className="mr-2 h-4 w-4" />
          Close
        </button>
      </div>

      {!loaded && (
        <div className="absolute inset-0 flex items-center justify-center">
          <Spinner size="lg" label="Loading preview" />
        </div>
      )}

      <iframe
        src={`/store/${encodeURIComponent(username)}/join`}
        title="Join page preview"
        onLoad={() => setLoaded(true)}
        className={`h-full w-full border-0 ${loaded ? "" : "invisible"}`}
      />
    </div>
  );
}
